import { Action } from "@ngrx/store";

export const SET_CURRENT_TANK_NOTIFICATIONS = "[TankNotification] SetCurrentTank";

export class SetCurrentTankNotifications implements Action {
  readonly type = SET_CURRENT_TANK_NOTIFICATIONS;

  constructor(public currentTankNotifications: any) { }
}

export type Actions =
  | SetCurrentTankNotifications;
